import { Component, OnInit } from '@angular/core';

import { AmplitudeService } from '@sondermind/amplitude';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})

export class AppComponent implements OnInit {
  constructor(
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    this.amplitudeService.setupSessionReplay();
  }
}
